//description: random lower case alphabet string generator, this is used for unique id for each widget

function UuidGenerator()
{
	this.get = function()
	{
		return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[x]/g, function(c) {
			var num = Math.random() *16 | 0, v = c === 'x' ? num : (num&0x3|0x8);
     
			return v.toString(16);
		});
	}
}

module.exports = new UuidGenerator();


// WEBPACK FOOTER //
// ./src-client-lib/utils/uuid-generator.js